import { isNaN } from 'lodash';
import React from 'react';
import { Navigate } from 'react-router';
import Error404 from '../../../Error404';
import { ACCESS_TYPE, ROUTES, TAB_KEYS } from '../../../common/constants';
import useRouter from '../../../common/useRouter';
import HasAccess from '../../../components/HasAccess';

const RedirectToProjectDetails = () => {
  const {
    params: { projectId },
  } = useRouter();
  if (isNaN(Number(projectId))) {
    return <Error404 />;
  }

  const hasInspectionAccess = HasAccess({ type: ACCESS_TYPE.INSPECTION });
  const hasInstructionAccess = HasAccess({ type: ACCESS_TYPE.INSTRUCTION });
  const hasRegisterAccess = HasAccess({ type: ACCESS_TYPE.REGISTER });

  let redirectPath;
  if (hasInspectionAccess) {
    redirectPath = TAB_KEYS.EQC;
  } else if (hasInstructionAccess) {
    redirectPath = TAB_KEYS.INSTRUCTION;
  } else if (hasRegisterAccess) {
    redirectPath = TAB_KEYS.REGISTER;
  } else {
    return <Error404 />;
  }

  return <Navigate to={`${ROUTES.PROJECTS}/${projectId}/${redirectPath}`} />;
};

export default RedirectToProjectDetails;
